<template>
  <div class="user_center_container">
    <h2 class="user_center_title">用户中心</h2>
    <el-card>
    <div class="userInfo">
      <el-descriptions title="用户信息" border>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i> 用户名
          </template>{{userInfoList.username}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-s-check"></i> 用户昵称
          </template>
          {{userInfoList.nick_name}}</el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-time"></i> 加入日期
          </template>{{userInfoList.date_joined}}</el-descriptions-item>
        <el-descriptions-item v-if="userInfoList.is_limited">
          <template slot="label">
            <i class="el-icon-odometer"></i> 账号有效期
          </template>
          {{userInfoList.valid_period}} 天</el-descriptions-item>
        <el-descriptions-item v-else>
          <template slot="label">
            <i class="el-icon-odometer"></i> 账号有效期
          </template>
          无限制</el-descriptions-item>
        <el-descriptions-item v-if="userInfoList.school_name">
          <template slot="label">
            <i class="el-icon-school"></i> 学校
          </template>
          <el-tag size="small">{{userInfoList.school_name.school_name}}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item v-if="userInfoList.school_name">
          <template slot="label">
            <i class="el-icon-s-home"></i> 学校地址
          </template>{{userInfoList.school_name.school_address}}</el-descriptions-item>
      </el-descriptions>
    </div>
    </el-card>

    <div class="user_loginRecord">
      <el-card>
        <el-descriptions title="登录记录" border></el-descriptions>
        <el-table
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          v-loading.fullscreen.lock="true"
          :data="this.loginRecordList"
          stripe
          border
          style="width: 100%">
          <el-table-column prop="add_date" label="登录日期" width="300"></el-table-column>
          <el-table-column prop="ip" label="IP地址" width="300"></el-table-column>
          <el-table-column prop="location" label="位置信息" width="300"></el-table-column>
          <el-table-column label="本次学习的课程" width="300">
            <template slot-scope="scope">
              <!-- <el-table
              :data="scope.row.course_name"
              stripe
              style="width: 100%">
              <el-table-column prop="id" label="课程ID"></el-table-column>
              <el-table-column prop="course_name" label="课程名称"></el-table-column>
              </el-table> -->
              <div v-if="scope.row.course_name">
                <el-tag v-for="course in scope.row.course_name" :key="course.id" size="small">{{course.course_name}}</el-tag>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      queryInfo: {
        token: ''
      },
      userInfoList: [],
      loginRecordList: [],
      loading: false
    }
  },
  created () {
    this.queryInfo.token = window.sessionStorage.getItem('token')
    this.getUserInfo()
    this.getLoginRecordList()
  },
  methods: {
    async getUserInfo () {
      const useId = window.sessionStorage.getItem('user_id')
      const { data: res } = await this.$http.get('users/' + useId, { params: this.queryInfo })
      this.userInfoList = res
      console.log('getUserInfo:', res)
      // console.log(this.userInfoList.school_name.school_name)
      if (!res) return this.$notify({ title: '失败', message: '获取用户个人信息失败!', type: 'error' })
      this.$notify({ title: '成功', message: '获取用户个人信息成功!', type: 'success' })
    },
    async getLoginRecordList () {
      this.loading = true
      // const useId = window.sessionStorage.getItem('user_id')
      const { data: res } = await this.$http.get('V2/login_record/', { params: this.queryInfo })
      this.loginRecordList = res
      console.log('getLoginRecordList', res)
      if (!res) return this.$notify({ title: '失败', message: '获取登录记录失败!', type: 'error' })
      this.loading = false
      this.$notify({ title: '成功', message: '获取登录记录成功!', type: 'success' })
    }
  }
}
</script>

<style lang="less" scoped>
h2{
  text-align: center;
}
.userInfo{
  padding-top: 20px;
}
.user_loginRecord{
  padding-top: 40px;
}
</style>
